<div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
  style="top: 50px;" data-backdrop="true" data-keyboard="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div id="alertTitle" class="modal-header" style="background-color: #1a237e; color: #fff; font-size: 18px; font-weight: bold; padding: 10px 15px; margin: 0; border-radius: 0; border-bottom: none; position: relative;">
        <span id="alertTitleText" style="display: inline-block; color: #fff; text-transform: uppercase;">Title!</span>
        <button type="button" class="close" aria-label="Close" id="modalCloseBtn" (click)="closeModal()" style="position: absolute; right: 15px; top: 50%; transform: translateY(-50%); font-size: 28px; font-weight: bold; line-height: 1; color: #fff; opacity: 0.8; background: transparent; border: none; cursor: pointer; padding: 0; margin: 0; z-index: 1;">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding: 0;">
        <div id="alertMessage" style="font-size: 14px; color: #f00; padding: 10px 15px; margin: 0;">
          Message..
        </div>
      </div>
    </div>
  </div>
</div>
<section>
  <div>
    <div class="inner-wrap">
      <p class="text-center">
        <img src="assets/modules/dummy-assets/common/img/GovEVA.png" alt="DigiCompany">
      </p>
      <form autocomplete="off" [formGroup]="loginForm">
        <div class="form-group">
          <label>E-mail address / Username:</label>
          <input [(ngModel)]="userName" #userInput (focusout)="getCompaniesByEmailId()" (blur)="checkEmailValidity()"  class="form-control" type="email"
            name="Email" autocomplete="email" [formControl]="loginForm.controls['userName']">
          <div *ngIf="loginForm.controls['userName'].hasError('required') && loginForm.controls['userName'].touched"
            class="form-control-error-custom" style="text-align:left;">
            Email / Username is required.
          </div>
          <div *ngIf="loginForm.controls['userName'].hasError('email') && loginForm.controls['userName'].touched"
            class="form-control-error-custom" style="text-align:left;">
            Please enter a valid email address.
          </div>
        </div>
        <div class="form-group">
          <label>Select your company:</label>
          <div class="below" style="border:0"></div>
          <ng-select [notFoundMsg]="isEmailForCompany" [(ngModel)]="selectedCompanyId"
            bindLabel="label" bindValue="value"
            (change)="companySelection(selectedCompanyId)" class="companyddl" [multiple]=false [items]="companyList"
            [formControl]="loginForm.controls['companyName']" style="text-align:left;">
          </ng-select>
          <div
            *ngIf="loginForm.controls['companyName'].hasError('required') && loginForm.controls['companyName'].touched && companyList.length"
            class="form-control-error-custom" style="text-align:left;">
            Company Name is required.
          </div>
        </div>

        <div class="form-group input-box" >
          <label>Password:</label>
          <div id="fake-input" class="fake-input form-control"><span class="blinking-cursor"></span></div>
          <div class="password-wrapper">
            <input
              [type]="passwordVisible ? 'text' : 'password'"
              class="form-control"
              autocomplete="off"
              (focusin)="blinkCur()"
              (focusout)="blinkCurOut()"
              (keyup)="RemoveSavePassword()"
              (keyup.enter)="login()"
              [formControl]="loginForm.controls['password']">
            
            <i class="fa" [ngClass]="passwordVisible ? 'fa-eye' : 'fa-eye-slash'" (click)="togglePasswordVisibility()" (keydown.enter)="togglePasswordVisibility()" (keydown.space)="togglePasswordVisibility(); $event.preventDefault()" tabindex="0" role="button"></i> <!-- Eye icon -->
          </div> <!-- Eye icon -->
          <div *ngIf="loginForm.controls['password'].hasError('required') && loginForm.controls['password'].touched"
            class="form-control-error-custom" style="text-align:left">
            Password is required.
          </div>
        </div>


        <!-- <div class="form-group input-box">
          <label>Password:</label>
          <div id="fake-input" class="fake-input form-control"><span class="blinking-cursor"></span></div>
          <input autocomplete="off" class="real-input" (focusin)="blinkCur()" (focusout)="blinkCurOut()"
            (keyup)="RemoveSavePassword()" type="text" (keyup.enter)="login()" name="Password"
            [formControl]="loginForm.controls['password']">
          <div *ngIf="loginForm.controls['password'].hasError('required') && loginForm.controls['password'].touched"
            class="form-control-error-custom" style="text-align:left;padding-top: 32px;">
            Password is required.
          </div>
        </div> -->

        <div *ngIf="!isADCompany" class="forgot-password-wrapper">
          <a class="forgot-password-link"
            [routerLink]="['/requestPassword']">Forgot Password?</a>
        </div>
        <div class="clearfix"></div>
        <div class="row" *ngIf="companyConfig?.normalLogin">

          <!-- <div [ngClass]="{'col-md-12': !(companyConfig?.authLogin == 'Active' && companyConfig?.twoFactor == 'Inactive')
          && !(companyConfig?.authLogin == 'Inactive' && companyConfig?.twoFactor == 'Inactive'), 
          'col-md-6': ((companyConfig?.authLogin == 'Active' && companyConfig?.twoFactor == 'Inactive') 
          || (companyConfig?.authLogin == 'Inactive' && companyConfig?.twoFactor == 'Inactive'))}">
            <div class="text-center">
              <button class="btn btn-primary btn-block mr-2 mb-2" style="margin-top: 10px;"
                [disabled]="!loginForm.valid || LoginDisabled" (click)="login()">
                <i aria-hidden="true"></i>Login <span *ngIf="companyConfig?.twoFactor == 'Active'"> (2Fa) </span></button>
            </div>
          </div> -->

          <div class="col" *ngIf="!environmentSettings.MfaLogin || userName === 'superadmin@gmail.com'">
            <div class="text-center">
              <button class="btn btn-primary btn-block mr-2 mb-2" style="margin-top: 10px;"
                [disabled]="!loginForm.valid || LoginDisabled" 
                [class.loading]="LoginDisabled"
                (click)="login() ">
                <i aria-hidden="true"></i>Login </button>
            </div>
          </div>

          
          <div class="col" *ngIf="environmentSettings.MfaLogin && !(userName === 'superadmin@gmail.com')">
            <div class="text-center">
              <button class="btn btn-primary btn-block mr-2 mb-2" style="margin-top: 10px;"
                [disabled]="!loginForm.valid || LoginDisabled" 
                [class.loading]="LoginDisabled"
                (click)="login()" [queryParams]="{returnUrl: redirectPath}">
                <i aria-hidden="true"></i>Login (2Fa) </button>
            </div>
          </div>
          
          <div class="col" *ngIf="!environmentSettings.MfaLogin">
         
            <div class="text-center">
              <button class="btn btn-primary btn-block mr-2 mb-2" type="button" style="margin-top: 10px;"
                [routerLink]="['/login-with-otp']" [queryParams]="{returnUrl: redirectPath}">   
                <i aria-hidden="true"></i>Login With OTP</button>
            </div>
          </div>
        </div>
        <!-- <div class="text-center">Or</div> -->
        <!-- <div class="row" >
          <div class="col-md-12">
            <div class="text-center">
              <button class="btn btn-primary btn-block mr-2 mb-2" style="margin-top: 10px;" (click)="login('loginByGoogle')">
                <i aria-hidden="true"></i>Login with Google</button>
            </div>
          </div>
        </div> -->
      </form>
    </div>
  </div>
</section>
